import Vue from 'vue'
import { home, deliverModel } from '@/config'

const api = `/api/admins/menus`

let userAddress = home // 读取配置文件指定首次加载
let defaultAddress = ''

const checkStorageMenuActive = (map) => {
  let storageMenuActive = window.sessionStorage.getItem('menuActive')
  if (storageMenuActive in map) return storageMenuActive
  return null
}

const menuResolve = (arr) => {
  let menuTrend = [] // 动态台账菜单
  let menuCache = []
  let menuMap = {}
  arr.forEach((item, index) => {
    if (item.ledgerId) menuTrend.push(item)
    menuMap[item.address] = item
    if (item.isCache && item.isCache === '1') menuCache.push(item.address)
    if (index === 0) defaultAddress = item.address
    if (item.children) {
      item.children.forEach((v, i) => {
        if (v.ledgerId) menuTrend.push(v)
        menuMap[v.address] = v
        if (v.isCache && v.isCache === '1') menuCache.push(v.address)
        if (index === 0 && i === 0) defaultAddress = v.address
      })
    }
  })
  return {
    trend: menuTrend,
    map: menuMap,
    cache: menuCache
  }
}

const scrollView = (state) => {
  const id = `j-quick-tab-${state.menuMap[state.menuActive] && state.menuMap[state.menuActive].menuId}`
  document.getElementById(id) && document.getElementById(id).scrollIntoView({ behavior: 'smooth', inline: 'end' })
}

const state = {
  menuMap: {},
  menuList: [],
  menuQuick: [],
  menuActive: '',
  menuCache: [],
  menuDestroy: []
}

const mutations = {
  menuDestroy (state, payload) {
    state.menuDestroy = payload
  },
  menuMap (state, payload) {
    state.menuMap = payload
  },
  menuList (state, payload) {
    state.menuList = payload
  },
  menuCache (state, payload) {
    state.menuCache = payload
  },
  menuActive (state, payload) {
    state.menuActive = payload
    window.sessionStorage.setItem('menuActive', payload)
    Vue.nextTick(() => scrollView(state))
  },
  menuQuick (state, payload) {
    state.menuQuick = payload
    window.sessionStorage.setItem('menuQuick', JSON.stringify(state.menuQuick))
  },
  decreaseQuick (state, index) {
    this.commit('JMenu/menuDestroy', [state.menuQuick[index].address])
    state.menuQuick.splice(index, 1)
    window.sessionStorage.setItem('menuQuick', JSON.stringify(state.menuQuick))
  },
  additionQuick (state, quick) {
    state.menuQuick.push(quick)
    window.sessionStorage.setItem('menuQuick', JSON.stringify(state.menuQuick))
    Vue.nextTick(() => scrollView(state))
  },
  openMenu (state, menuName) {
    scrollView(state)
    this.commit('JMenu/menuDestroy', []) // 重置销毁数组
    if (state.menuActive === menuName) return
    if (deliverModel === 'router') Vue.router.push({ name: menuName }, () => {})
    let isExist = false
    state.menuQuick.some(item => {
      if (item.address === menuName) {
        this.commit('JMenu/menuActive', menuName)
        isExist = true
        return true
      }
    })
    if (!isExist) {
      this.commit('JMenu/additionQuick', state.menuMap[menuName] || {})
      this.commit('JMenu/menuActive', menuName)
    }
  }
}

const actions = {
  async getMenuList (content) {
    const { data } = await Vue.http.get(api).catch(error => { console.error(`${api}接口，菜单信息获取异常`,error.response) })
    if (data.status != 'yes') return Vue.prototype.$message.error(`${api}接口，菜单信息获取异常`)
    let { map, cache, trend } = menuResolve(data.data)
    let menuQuick = JSON.parse(window.sessionStorage.getItem('menuQuick') || '[]')
    let initActive = checkStorageMenuActive(map) || (userAddress && map[userAddress] && map[userAddress].address) || defaultAddress
    content.commit('menuList', data.data)
    content.commit('menuMap', map)
    content.commit('menuCache', cache)
    if (menuQuick.length > 0) {
      content.commit('menuQuick', menuQuick)
    }
    if (deliverModel === 'router') window.addEventListener('popstate', () => { content.commit('menuActive', Vue.router.history.current.name) })
    return { initActive, trendMenus: trend }
  }
}

const getters = {
  menuInclude (state) {
    return state.menuQuick.map(item => item.address)
  }
}

// 模块方式注册
export const JMenu = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
